"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const webview_app_1 = require("@/webview_app");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const _1 = require(".");
function default_1({ open, closeDialog, companyRegisterForm, }) {
    (0, webview_app_1.useAABBDialogClose)({ open, dialogName: 'company-address' });
    const companyAddressForm = (0, react_hook_form_1.useForm)({ mode: 'onChange' });
    const { watch: watchCompanyAddressForm, reset: resetCompanyAddressForm } = companyAddressForm;
    const companyPostCode = watchCompanyAddressForm('company_post_code');
    const companyAddress = watchCompanyAddressForm('company_address');
    (0, react_1.useEffect)(() => {
        if (!open)
            resetCompanyAddressForm();
    }, [open]);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: open, fullScreen: maxWidth768, PaperProps: {
                sx: {
                    width: maxWidth768 ? '100%' : '480px',
                    height: maxWidth768 ? '100%' : '90vh',
                    borderRadius: 0,
                    margin: 0,
                },
            } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: { padding: '13px 11px' } }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: { p: 0 }, onClick: closeDialog }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderBackSvg, {}) })) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '24px',
                        height: '100%',
                        padding: '20px 16px',
                    } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle2 gray-80" }, { children: t('사업장 소재지') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '10px' } }, { children: [(0, jsx_runtime_1.jsx)(_1.CompanyAddressSearch, { companyAddressForm: companyAddressForm, maxWidth768: maxWidth768 }), companyPostCode && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "crdi_input body2 gray-80 surface-bg" }, { children: companyPostCode })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "crdi_input body2 gray-80 surface-bg", translate: "no" }, { children: companyAddress })), (0, jsx_runtime_1.jsx)(_1.CompanyAddressDetail, { companyAddressForm: companyAddressForm })] }))] }))] })), (0, jsx_runtime_1.jsx)(_1.CompanyAddressSave, { companyAddressForm: companyAddressForm, companyRegisterForm: companyRegisterForm, closeDialog: closeDialog })] })) }));
}
exports.default = default_1;
